import React from 'react';
import classNames from 'classnames';
import "./radio.css";


const getBorderRadius = ({index, length}) => {
  if (index === 0) return "8px 0 0 8px";
  if (index === length - 1) return "0 8px 8px 0";
  return "0";
};

const Radio = (
  {
    data,
    select,
    selected
  }
) => {
  return (
    <div className="radio">
      {
        data.map((d, i) => (
          <div
            style={{
              width: `${100/data.length}%`,
              borderRadius: getBorderRadius({ index: i, length: data.length }),
              borderLeft: i === 0 ? '1px solid #e9ecef' : null
            }}
            key={i}
            className={classNames({
              "radio__item": true,
              "radio__item__selected": d === selected
            })}
            onClick={() => select(d)}
          >{ d }</div>
        ))
      }
    </div>
  )
};

export default Radio;


// WEBPACK FOOTER //
// ./src/components/radio/radio-component.js